import type { QueryClient } from "@tanstack/react-query";
import { logger, LOGS } from "../../utils";
import { setQueryDataOverFetch } from "../../utils/query/setQueryDataOverFetch";
import { ApiManager } from "../api";
import { toDomainAcceptedTodo } from "../api/mappers/todo.mapper";
import type { TodoItem } from "../mail/types/mail";
import { TODOS_KEY } from "./queries";

export class UserTodos {
    private apiManager: ApiManager;

    private queryClient: QueryClient;

    constructor(apiManager: ApiManager, queryClient: QueryClient) {
        this.apiManager = apiManager;
        this.queryClient = queryClient;
    }

    public replaceAll(userTodos: TodoItem[]): void {
        setQueryDataOverFetch(this.queryClient, TODOS_KEY, userTodos);
    }

    /** Todos acceptés lus depuis le backend, sans passer par le cache. */
    public fetchUserTodos = async (): Promise<TodoItem[]> => {
        logger.info(LOGS.UserManager, "fetchUserTodos()");

        try {
            return (await this.apiManager.getUserTodoItems()).map(
                toDomainAcceptedTodo,
            );
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : String(error);
            const errorText = `Error fetching userTodos: ${errorMessage}`;
            logger.error(LOGS.UserManager, errorText);
            throw new Error(errorText);
        }
    };

    public async getUserTodos(
        forceFetchTodosFromDb: boolean = false,
    ): Promise<TodoItem[]> {
        const query = { queryKey: TODOS_KEY, queryFn: this.fetchUserTodos };

        return forceFetchTodosFromDb
            ? this.queryClient.fetchQuery({ ...query, staleTime: 0 })
            : this.queryClient.ensureQueryData(query);
    }
}
